import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { FontIcon } from '@bingads-webui-react/fabric-control';
import { getImageExtensionItemStyles } from '../styles/image-extensions-list-style';

export function ImageExtensionItemSeeMoreLess({
  i18n,
  onSelectShowAll,
  seeMoreItemsCount,
  seeLess,
}) {
  const classes = useDefaultStyles(getImageExtensionItemStyles);
  const text = seeLess
    ? i18n.getString(_TL_('See less'))
    : `+ ${seeMoreItemsCount} `.concat(i18n.getString(_TL_('more')));

  return (
    <div className={classnames(classes.imageExtensionContainer, 'image-extension-container')}>
      <button
        role="link"
        className={classnames(classes.btnItem, seeLess ? `${classes.textItem} see-less-link` : 'see-more-link')}
        onClick={() => onSelectShowAll(!seeLess)}
        onKeyDown={() => onSelectShowAll(!seeLess)}
        aria-label={text}
      >
        { !seeLess &&
          <div className="see-more-icon">
            <FontIcon iconName="ViewAll" />
          </div>
        }
        <div>{text}</div>
      </button>
    </div>
  );
}

ImageExtensionItemSeeMoreLess.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onSelectShowAll: PropTypes.func.isRequired,
  seeMoreItemsCount: PropTypes.number.isRequired,
  seeLess: PropTypes.bool,
};

ImageExtensionItemSeeMoreLess.defaultProps = {
  seeLess: false,
};
